import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../../context/I18nContext';

export const ProductFilter = ({ activeCategory, setActiveCategory }) => {
  const { t } = useTranslation();

  const categories = [
    { id: 'produce', label: t('home.categories.produce'), image: 'https://images.unsplash.com/photo-1550989460-0adf9ea622e2?auto=format&fit=crop&q=80&w=800' },
    { id: 'dairy', label: t('home.categories.dairy'), image: 'https://images.unsplash.com/photo-1452195100486-9cc805987862?auto=format&fit=crop&q=80&w=800' },
    { id: 'meat', label: t('home.categories.meat'), image: 'https://images.unsplash.com/photo-1558030006-450675393462?auto=format&fit=crop&q=80&w=800' },
    { id: 'sea', label: t('home.categories.sea'), image: 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?auto=format&fit=crop&q=80&w=800' },
    { id: 'bakery', label: t('home.categories.bakery'), image: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&q=80&w=800' },
    { id: 'wine', label: t('home.categories.wine'), image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&q=80&w=800' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-24">
      <motion.button
        whileHover={{ y: -8, scale: 1.03 }}
        onClick={() => setActiveCategory('all')}
        className={`relative aspect-[4/5] rounded-[2.5rem] overflow-hidden group transition-all duration-500 border-2 ${
          activeCategory === 'all' 
            ? 'border-[#D4B483] shadow-2xl shadow-[#D4B483]/20' 
            : 'border-transparent hover:border-[#D4B483]/50 hover:shadow-2xl hover:shadow-zinc-200'
        }`}
      >
        <div className="absolute inset-0 bg-zinc-900 flex items-center justify-center text-center p-4">
          <span className="text-white font-black text-[10px] tracking-[0.3em] uppercase">{t('marketplace.allIngredients')}</span>
        </div>
      </motion.button>

      {categories.map((cat) => (
        <motion.button
          key={cat.id}
          whileHover={{ y: -8, scale: 1.03 }}
          onClick={() => setActiveCategory(cat.id)}
          className={`relative aspect-[4/5] rounded-[2.5rem] overflow-hidden group transition-all duration-500 border-2 ${
            activeCategory === cat.id 
              ? 'border-[#D4B483] shadow-2xl shadow-[#D4B483]/20' 
              : 'border-transparent hover:border-[#D4B483]/50 hover:shadow-2xl hover:shadow-zinc-200'
          }`}
        >
          <img 
            src={cat.image} 
            alt={cat.label} 
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
          />
          <div className={`absolute inset-0 transition-colors duration-500 ${
            activeCategory === cat.id ? 'bg-[#1A2E22]/40' : 'bg-black/40 group-hover:bg-black/50'
          }`} />
          <div className="absolute inset-0 flex items-center justify-center text-center p-6">
            <span className="text-white font-black text-[10px] tracking-[0.25em] uppercase leading-relaxed drop-shadow-xl">
              {cat.label}
            </span>
          </div>
        </motion.button>
      ))}
    </div>
  );
};